import React, { useState } from "react"
import Helmet from "react-helmet"
import swal from 'sweetalert2'
import Loader from 'react-loader-spinner'

import Header from '../components/Header'

import { TextSection } from "../components/Section"
import EmbedMap from "../components/EmbedMap"
import ContactImage from '../assets/images/find-us/4.png'
import { sendMessage } from "../lib/API"




export default () => {
    const siteTitle = "Blackheath and Charlton Baptist Church - Contact"
    const iconStyle = { }
    const headerStyle = { }
    const contactStyle = { fontWeight: 500 }

    // const pageData = useContext( BannerContext )[pageName]
    const pageName = 'contact-banners'

    // const { header, banners } = pageData || { header: null, banners: null }
    const headerImages = [ ContactImage ]
    const headerTitle = 'Contact Us'
    // const headerIcon = <span className="icon major"><i className="fas fa-phone-alt"></i></span>
    const headerButtons = [
        { url: "/events#one", text: "View Events" }
    ]

    const [ loading, setLoading ] = useState( false )
    const [ name, setName ] = useState( '' )
    const [ email, setEmail ] = useState( '' )
    const [ subject, setSubject ] = useState( '' )
    const [ message, setMessage ] = useState( '' )

    const send = async e => {
        e.preventDefault()
        e.stopPropagation()
        // console.log( e )
        setLoading( true )
        const data = { name, email, subject, message }
        const res = await sendMessage( data )
        setLoading( false )
        
        if( res.sent ) {
            swal.fire( 'Success', 'Message sent successfully', 'success' ).then( () => {
                setName( '' )
                setEmail( '' )
                setSubject( '' )
                setMessage( '' )
            } )
            
        }
        else{
            swal.fire( 'Could not send message', 'Please try again later', 'error' )
        }
    }

    const changeValue = ( e, handler ) => handler( e.target.value ) 
    

    return (
            
        <div id="contact-page">
            <Helmet title={siteTitle} />
            <Header images={headerImages} headerTitle={headerTitle} tint={0.4} headerButtons={headerButtons} />
            {/* <Slideshow images={[ ContactImage ]} tint={0.3} />          */}

            {/* <section id="info" className="main style1 special">
                <div className="col-12 contact-details">
                    <div className="grid-wrapper">
                        <div className="col-4 clickable" onClick={() => typeof window !== 'undefined' ? window.location.replace( 'mailto:admin@bcbchurch.co.uk' ) : null}>
                            <header className="major">
                                <h2 style={headerStyle}>Email</h2>
                            </header>
                            <span className="icon major"><i className="fa fa-envelope" style={iconStyle} /></span>
                            <p style={contactStyle}>admin@bcbchurch.co.uk</p>
                        </div>
                        <div className="col-4">
                            <header className="major">
                                <h2 style={headerStyle}>Phone</h2>
                            </header>
                            <span className="icon major"><i className="fa fa-phone" style={iconStyle} /></span>
                            <p style={contactStyle}>020 8856 8654</p>
                        </div>
                        <div className="col-4 clickable" onClick={() => navigate( '/contact/#contact-map' )}>
                            <header className="major">
                                <h2 style={headerStyle}>Address</h2>
                            </header>
                            <span className="icon major"><i className="fa fa-map-marker-alt" style={iconStyle} /></span>
                            <p style={contactStyle}>Blackheath & Charlton Baptist Church <br />  Marlborough Lane <br /> London, SE7 7DF</p>

                        </div>
                    </div>
                </div>
            </section> */}

            <TextSection
                id="contact-message"
                title="We'd love to hear from you, send us a message"
                description=""
            />

            <section id="form" method='POST' className="main style1 special" onSubmit={send} >
                <div className="grid-wrapper">
                    <div className="col-12 contact-form">
                        <form>
                        <div className="grid-wrapper">
                            <div className="col-12">
                                {/* <header className="major">
                                    <h2 style={headerStyle}>Send a Message</h2>
                                </header> */}
                            </div>
                            <div className="col-6">
                                <label>Full Name</label>
                                <input className="form-input" type="text" name="name" placeholder="Name*" required value={name} onChange={e => changeValue( e, setName )} />
                            </div>

                            <div className="col-6">
                                <label>Email Address</label>
                                <input className="form-input email" type="email" name="email" placeholder="Email*" required value={email} onChange={e => changeValue( e, setEmail )} />
                            </div>

                            <div className="col-12" style={{ marginTop: 40 }}>
                                <label>Subject</label>

                                <input className="form-input" type="text" name="subject" placeholder="Subject*" required value={subject} onChange={e => changeValue( e, setSubject )} />
                            </div>

                            <div className="col-12" style={{ marginTop: 40 }}>
                                <label>Message</label>
                                <textarea rows={5} autoComplete={false} placeholder="Message*" value={message} className="form-input" style={{ resize: "none" }} onChange={e => changeValue( e, setMessage )}/>
                            </div>
                        </div>
                            

                            <br />{!loading ? <input type="submit" value="Submit" className="button special" /> :
                            <Loader
                                type="Puff"
                                color="#00BFFF"
                                height={40}
                                width={50}
                            />}
                        </form>
                    </div>
                </div>
            </section>
            
            <section data-aos="fade-up" id="map" className="main style1">
                 <EmbedMap /> 
            </section>


        </div>
    )
}

